import { useMemo } from 'react';

import { AgreementType } from '../../../redux/api/agreements/interfaces';
import { useGetAgreementContent } from '../../../redux/api/agreementsApi';

export function useAgreementContent(
  agreementType: AgreementType,
  enabled = true,
) {
  const agreementContent = useGetAgreementContent(agreementType, {
    skip: !enabled,
  });

  return useMemo(() => agreementContent, [agreementContent]);
}
